import { useCallback, useState } from "react";

import { errorsConfig } from "../config/errors";

import { IInformations, IUseInformations } from "../interfaces/informations";
import { IStatus } from "../interfaces/status";

export const useInformations = (props: IUseInformations) => {
  const [informations, setInformations] = useState<IInformations>();

  const getInformationsClasses = useCallback(() => {
    return `${informations?.verifying ? "verifying" : ""} ${
      informations?.validate ? "validate" : ""
    } ${!!informations?.error ? "error" : ""}`;
  }, [informations]);

  const clearInformations = useCallback(() => {
    const informationEl: HTMLDivElement | null = props.ref.current;

    if (informationEl) {
      informationEl.classList.remove("error");
      informationEl.innerHTML = "";
    }
  }, [props.ref]);

  const onValidateSetError = useCallback((message: string) => {
    setInformations({ verifying: false, error: message });
  }, []);

  const onValidateNext = useCallback(() => {
    clearInformations();

    setInformations({ verifying: false, validate: true });
  }, []);

  const onValidate: React.FocusEventHandler<HTMLElement> = (event) => {
    const {
      dataset: { status },
    } = event.currentTarget;

    setInformations({ verifying: true });

    switch (status as IStatus) {
      case "VALIDATED":
        onValidateNext();
        break;

      default:
        setInformations({ verifying: false, error: errorsConfig[status!] });
        break;
    }

    if (props.inputProps.onValidate) {
      setInformations({ verifying: true });

      props.inputProps.onValidate(onValidateSetError, onValidateNext);
    }
  };

  return {
    informations,
    setInformations,
    clearInformations,
    onValidate,
    getInformationsClasses,
  };
};
